<template>
  <!--begin::Form-->
  <form class="m-form m-form--fit m-form--label-align-right">
    <div class="m-portlet__body text-center">
      <div class="row">
        <div class="col">
          <div class="form-group m-form__group row">
            <div class="col-lg-12">
              <span class="d-block mb-5 mt-n2"><img
                alt=""
                :src="cdnURL+'/img/logos/logo-blue.png'"
                width="180px"
                height="auto"
              ></span>
              <h5 class="mb-3">
                {{ $t('support.TSBrand') }}
              </h5>
              <span class="d-block">{{ $t('support.TSAddress1') }}</span>
              <span class="d-block">{{ $t('support.TSAddress2') }}</span>
              <span
                class="d-block mt-3 m--regular-font-size-lg1 strong"
              ><small v-html="$t('contactUs.TelEmail-v2')" /></span>
              <div class="mt-5">
                <span class="col"><a
                  :href="socialLinks.facebook"
                  target="_blank"
                ><i
                  class="la la-facebook-official m--icon-font-size-lg5"
                /></a>  </span>
                <span class="col"><a
                  :href="socialLinks.twitter"
                  target="_blank"
                ><i
                  class="la la-twitter-square m--icon-font-size-lg5"
                /></a> </span>
                <span class="col"><a
                  :href="socialLinks.xml"
                  target="_blank"
                ><i
                  class="la la-rss-square m--icon-font-size-lg5"
                /></a> </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
  <!--end::Form-->
</template>

<script>

export default {
    data() {
        return {
            cdnURL: import.meta.env.TWC_CDN_URL,
        };
    },
    computed: {
        socialLinks() {
            return {
                facebook: import.meta.env.TWC_SOCIAL_FACEBOOK,
                twitter: import.meta.env.TWC_SOCIAL_TWITTER,
                xml: import.meta.env.TWC_SOCIAL_XML,
            };
        },
    },
};
</script>
